function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 3)",
  fill: "#2B9D8B",
  stroke: "#2B9D8B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 18v-2a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 4,
  r: 4
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}));

function SvgProfileActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profile_active.ef3b73ce.svg";
export { ForwardRef as ReactComponent };